<template>
  <Border v-if="config&&!pendding"  :config="config.border" :title="config.name" style="width:100%;height:100%;" :style="{filter:config.filter}">
    <component  ref="instance" :is="config.tag" v-bind="transformedProps" v-on="events" :layoutConfig="config" style="width:100%;height:100%;">
        <template v-if="config.children">
            <template v-for="(node, index) in config.children">
                <container v-if="node.slot" :config="node" :slot="node.slot" :key="node.id"></container>
                <container v-else :config="node" :slot="index"  :key="node.id"></container>
            </template>
        </template>
    </component>
  </Border>
</template>
<style lang="less">
    .edit-container{
        position: relative;
        .edit-toolbar{
            position: absolute;
            right: 0px;
            top: 0px;
            background: green;
        }
    }
</style>
<script>
import * as store from "./store";
import Border from './border'
import * as dataBuilder from '@/runtime-components/data-builder/index';
import * as transformUtil from '@/runtime-components/data-builder/transformer/index';
import * as datasetApi from './api/dataset';
export default {
  name: "container",
  props: {
    config: {
      type: Object,
      default: null
    },
    isEditing: {
      type: Boolean,
      default: true //TODO: should be false by default
    }
  },
  components:{Border},
  data() {
    return {
      props: null,
      events: {},
      pendingProps:{},
      asyncPropsValus:{},
      transformedPropsValus:{},
      transformedProps:{},
    };
  },
  computed:{
    pendding(){
      return Object.keys(this.pendingProps).length>0;
    },
    propsBeforeTransformed(){
      let result = {};
      for (const key in this.config.props) {
        if (this.config.props.hasOwnProperty(key)&&!this.config.asyncProps.hasOwnProperty(key)) {
          result[key] = this.config.props[key];
        }else{
          if(this.asyncPropsValus&&this.asyncPropsValus.hasOwnProperty(key)){
            result[key] = this.asyncPropsValus[key]
          }else{
            result[key] = this.config.props[key]
          }
        }
      }
      // Object.assign(result, this.asyncPropsValus);
      return result;
    }
  },
  mounted() {
    let me = this;
    store.instances[this.config.id] = me;
    // this.props = this.config.props;
    if (this.config.events) {
      for (let i = 0; i < this.config.events.length; i++) {
        const event = this.config.events[i];
        this.$refs.instance.$on(event.eventName, function(data) {
          if(event.transformers){
            let transformers = event.transformers.map(f=>{
              return Object.assign({},f,{
                func:me.$functions[f.func],
              })
            })
            transformUtil.concatFunc({source:me.$refs.instance, data}, transformers, (result)=>{
              let componentInstance = store.instances[event.to].$refs.instance;
              if(event.handlerType==='variable'){
                let result1 = result;
                if(typeof result === 'object'&&event.isMerge){
                  result1 = Object.assign(Array.isArray(result)?[]:{}, componentInstance.$attrs.layoutConfig.props[event.handler], result);
                }
                me.$set(componentInstance.$attrs.layoutConfig.props, event.handler, result1);
              }else{
                componentInstance[event.handler].call(componentInstance, result);
              }
            })
          }else{
            let componentInstance = store.instances[event.to].$refs.instance;
            componentInstance[event.handler].call(componentInstance, data);
          }
        });
      }
    }
    this.watchAsyncProps();
    this.watchPropsTransformers();
  },

  watch: {
    transformedPropsValus:{
      handler(){
        let me = this;
        if(this.$functions[this.config.propsTransformer]){
          let func = this.$functions[this.config.propsTransformer];
          func.call(this, this.transformedPropsValus, (result)=>{
            this.transformedProps = result;
          })
        }else{
          this.transformedProps = this.transformedPropsValus; 
        }
      },
      immediate:true,
      deep:true
    }
  },

  methods: {
    watchPropsTransformers(){
      for (const key in this.config.props) {
        this.$watch(`config.propTransformers.${key}`, (v)=>{
          let isAsync = this.config.asyncProps[key];
          let orginData;
          if(isAsync){
            orginData = this.asyncPropsValus&&this.asyncPropsValus[key];
          }else{
            orginData = this.config.props[key];
          }
          let transformers = this.config.propTransformers[key];
          if(transformers){
            transformers = transformers.map(f=>{
              return Object.assign({},f,{
                func:this.$functions[f.func],
              })
            })
            transformUtil.concatFunc(orginData, transformers, (result)=>{
              this.$set(this.transformedPropsValus,key, result);
            })
          }else{
            this.$set(this.transformedPropsValus,key, orginData);
          }
          
        }, {immediate:true});

        this.$watch(`propsBeforeTransformed.${key}`, (value)=>{
          let isAsync = this.config.asyncProps[key];
          let orginData;
          if(isAsync){
            orginData = this.asyncPropsValus&&this.asyncPropsValus[key];
          }else{
            orginData = this.config.props[key];
          }
          let transformers = this.config.propTransformers[key];
          if(transformers){
            transformers = transformers.map(f=>{
              return Object.assign({},f,{
                func:this.$functions[f.func],
              })
            })
            transformUtil.concatFunc(orginData, transformers, (result)=>{
              this.$set(this.transformedPropsValus,key, result);
            })
          }else{
            this.$set(this.transformedPropsValus,key, orginData);
          }
        }, {immediate:true})
      }
    },
    watchAsyncProps(){
      for (const key in this.config.asyncProps) {
        if (this.config.asyncProps.hasOwnProperty(key)) {
          this.$watch(`config.props.${key}`, (v)=>{
            this.requestAsyncProps(key);
          });
          this.requestAsyncProps(key);
        }
      }
    },

  requestAsyncProps(propName){
      if(!this.config.props[propName].datasetId){
        this.$set(this.asyncPropsValus, propName, this.config.props[propName]);
      }else{
        const dataBuilderType = this.config.asyncProps&&this.config.asyncProps[propName];
        if(dataBuilderType==='dataset'){
          let {datasetId} = this.config.props[propName];
          this.pendingProps[propName] = true;
          datasetApi.loadDataset(datasetId).then((datasetInfo)=>{
            let [libPrefix, datasetType] = datasetInfo.type.split('/');
            if(!datasetType&&libPrefix){
              datasetType = libPrefix;
              libPrefix = 'de';
            }
            let datasetHandler = store.libs[libPrefix].datasetsMap[datasetType].handler;

            if(datasetInfo.config==='none'){
              this.$set(this.asyncPropsValus, propName, []);
              delete this.pendingProps[propName];
            }else{
              let config = datasetInfo.config&&JSON.parse(datasetInfo.config);
              datasetHandler.fetch(config).then(data=>{
                this.$set(this.asyncPropsValus, propName, data);
                delete this.pendingProps[propName];
              })
            }
          });
        }
      }
  }
  }
};
</script>